import "./src/polyfills/array-find-last";
import "./src/polyfills/array-find-last-index";
import "expo-router/entry";
